export default {
  SET_LOADING (state, loading) {
    state.loading = loading
  }
}



// WEBPACK FOOTER //
// ./src/store/services/mutations.js